import React, { useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Selects from "react-select";
import { localApi } from "utils/imgApi";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyl = makeStyles(styDrop);
const useStyleSweet = makeStyles(styleSweet);

export default function DeletePosts(props) {
  const [itemPosts, setItemPosts] = React.useState([]);
  const [simpleSelectProd, setSimpleSelectProd] = React.useState("");
  const [postsObj, setPostsObj] = React.useState("");

  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);

  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyl();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api = localApi + `/posts/list/byAdminId/${userObj && userObj.id}`;

    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });

    const getResult = await result.json();
    setItemPosts(getResult && getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleSimpleProd = async (selectedOption) => {
    setSimpleSelectProd(selectedOption || "");

    const postId = String(selectedOption.value).split(" - ")[0].trim();

    const selectedPost = itemPosts.find(
      (post) => String(post.id) === String(postId),
    );
    console.log(selectedPost);

    setPostsObj(selectedPost);
  };

  const handleRemove = () => {
    setSubmitteds(true);
    setBtn(true);
  };

  const handleConfirm = () => {
    fetch(localApi + `/posts/delete/byId/${postsObj.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.message === "Deleted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Deleted Succesfully");
          setSubmittedConfirm(true);
        }
      });
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  const select = {
    width: "100%",
    maxWidth: 600,
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    menu: (state) => ({
      color: "#d81b60",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <DeleteForeverIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Delete Posts</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  />
                ) : null}
                {submitteds ? (
                  <SweetAlert
                    warning
                    style={{ display: "block", marginTop: "100px" }}
                    title="Are you sure?"
                    onConfirm={handleConfirm}
                    onCancel={() => hideAlerts()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                    cancelBtnCssClass={
                      classSweet.button + " " + classSweet.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                  />
                ) : null}

                {submittedConfirm ? (
                  <SweetAlert
                    success
                    style={{ display: "block", marginTop: "100px" }}
                    title="Deleted!"
                    onConfirm={() => hideAlerts()}
                    onCancel={() => hideAlerts()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Your imaginary product has been deleted.
                  </SweetAlert>
                ) : null}
                <GridItem xs={12} sm={12} md={12}>
                  <label className={classe.selectLabel}>Select Posts Id</label>
                  <Selects
                    styles={customStyles}
                    style={select}
                    placeholder="Select Product Id..."
                    value={simpleSelectProd}
                    name="simpleSelectProd"
                    onChange={handleSimpleProd}
                    options={
                      itemPosts &&
                      itemPosts.map((c) => ({
                        label: `${c.id} - ${c.category} - ${c.sizemm}`,
                        value: `${c.id} - ${c.category} - ${c.sizemm}`,
                      }))
                    }
                  />
                </GridItem>
                {simpleSelectProd ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <h5 className={classes.cardIconTitle}>
                      <small>
                        Description:-{" "}
                        <span style={{ color: "black" }}>
                          {postsObj.description}
                        </span>
                      </small>
                      <br />
                      <small>
                        Hastag:-{" "}
                        <span style={{ color: "black" }}>
                          {postsObj.hashtag}
                        </span>
                      </small>
                      <br />
                      <small>
                        Metal:-{" "}
                        <span style={{ color: "black" }}>{postsObj.metal}</span>
                      </small>
                      <br />
                      <small>
                        Making:-{" "}
                        <span style={{ color: "black" }}>
                          {postsObj.making}
                        </span>
                      </small>
                      <br />
                      <small>
                        Metal Gram:-{" "}
                        <span style={{ color: "black" }}>
                          {postsObj.metalGram}
                        </span>
                      </small>
                      <br />
                      <small>
                        Ready Gram:-{" "}
                        <span style={{ color: "black" }}>
                          {postsObj.readyGram}
                        </span>
                      </small>
                    </h5>
                  </GridItem>
                ) : (
                  ""
                )}
              </GridContainer>
              <br />
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Delete</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={handleRemove}
                  className={classes.updateProfileButton}
                >
                  Delete
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

DeletePosts.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
